<template>
    <div class="indexHead">
        <div class="HeadLeft">
            <img src="../../assets/logo.png" alt="">
        </div>
        <div class="HeadRight">
            <!-- <div class="HeadRightList">
                <router-link class="HeadRightItem" v-for="(item, index) in headrightlist" :key="index" :to="item.namelink" :class="{HeadRightItemactive:HeadRightItemCur==index}" @click="getHeadRightItemactive(index)">
                    {{item.name}}
                </router-link>
            </div> -->
            <el-menu
                :default-active="indexhead"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b">
                <el-menu-item v-for="(item, index) in headrightlist" :index="item.id" :key="index">{{item.name}}</el-menu-item>
            </el-menu>
        </div>
    </div>
</template>

<script>
export default {
    name: "indexHead",
    props: {
        indexhead: String
    },
    data(){
        return {
            headrightlist : [
                {name:'选号中心',id:'1'},
                {name:'我的订单',id:'2'}
            ]
        }
    },
    methods: {
        handleSelect(key, keyPath) {
            if( key == '1' ){
                this.$router.push({path:'/numbercenter'})
            }else if( key == '2' ){
                this.$router.push({path:'/order'})
            }
        }
    },
    mounted:function(){
        
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.indexHead {
    background: #545C64;
    height: 61px;
    width: 100%;
    min-width: 1280px;
    padding: 0 130px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    .HeadLeft {
        width: 150px;
        img {
            width: 100%;
        }
    }
    .HeadRight {
        .HeadRightList {
            display: flex;
            .HeadRightItem {
                height: 65px;
                line-height: 65px;
                margin:0 15px;
                padding: 0 8px;
                color: #959FB4;
                cursor: pointer;
                font-size: 16px;
            }
            .HeadRightItemactive {
                color: #FFD04B;
                border-bottom:3px solid;
            }
        }
    }
}
</style>
